import { render, staticRenderFns } from "./SchoolSubmitEPUAP.vue?vue&type=template&id=19bf1a5d&"
import script from "./SchoolSubmitEPUAP.vue?vue&type=script&lang=js&"
export * from "./SchoolSubmitEPUAP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports